<template lang="pug">
   
  .star-icon(@click="onClick" )
    star-svg

</template>

<script>
 
import gsap from 'gsap' 
import { mapState, mapMutations } from 'vuex' 
import { MODAL_STATES } from 'src/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'
import StarSvg from 'src/assets/svgs/menu-star.svg'

export default {

  props: {
    star_index: Number,
    show: Boolean
  },

  computed: { 
    ...mapState('app', [ 'home', 'motion_clamp' ]) 
  },

  mounted(){
    this.updateSelectedClass()
  },

  components: {
    StarSvg
  },

  methods: {

    onClick(){
      if(Env.mobile){
        this.$emit('navigate', this.star_index)
      }
    },
 
    updateSelectedClass(){  
      //this.$el.classList.toggle('selected', (this.star_index >= this.home.section_index))
    },

    onEnterComplete(){ 
      gsap.to(this.$el, 1 * this.motion_clamp, { scale: 0.65, ease: 'expo.out'}) 
    },

    enter(){  
      if(this.star_index >= this.home.section_index){

        let base_duration = AnimationConfig.home.section.duration
        const mult = Env.mobile ? 0.7 : 0.9
        let delay = ((base_duration * mult) + ((5-this.star_index) * 0.1)) * this.motion_clamp
        let duration = 0.1 * this.motion_clamp
        gsap.to(this.$el, duration, { opacity: 1, delay:  delay})
        gsap.to(this.$el, duration, {
          scale: 0.8, 
          transformOrigin: '50% 50%',
          ease: 'back.out(6)', 
          delay: delay,
          onComplete: this.onEnterComplete
        })
      } 
    },
 
    leave(){  
      gsap.set(this.$el, { scale: 0.65, opacity: 0.3}) 
    }

  },

  watch: {  
    'home.section_index'(val, prev){ 
      this.updateSelectedClass()
    },

    'show'(val){ 
      if(val){
        this.enter()
      } else {
        this.leave()
      }
    }
  }
  
}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.star-icon
  width: 3.2rem
  height: 3.2rem
  margin: 0 -0.1rem 0 0 
  opacity: 0.3 
  transform: scale(0.65)

  svg
    fill: #FFD730
 

  &.selected 
    opacity: 1

</style>
